import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModalController } from "@ionic/angular";
import { Subscription } from 'rxjs';
import { StaticClass } from 'src/components/shared-components/class/general-classes/static-classes';
import { ConnectionType } from 'src/components/shared-components/enum/enumSettings';
import { WeeklyPlanningButtonsActions } from 'src/model/enum/enumWeeklyPlanning';
import { iEvent } from 'src/components/shared-components/interfaces/iEvent';
import { EventService } from 'src/service/event.service';
import { NetworkService } from 'src/service/network.service';

@Component({
    selector: 'app-popup-select-operation',
    templateUrl: './popup-select-operation.component.html',
    styleUrls: ['./popup-select-operation.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupSelectOperationComponent implements OnInit, OnDestroy, iEvent {
  @Input() Title: string = "";
  @Input() Buttons: any[] = [];

  private _networkServiceSubscription: Subscription = null;
  public _eventSubscriptions: Array<Subscription> = null;

  public buttons: any[] = [];
  public toolBarColor: string = "primary";

  public weeklyPlanningButtonsActions = WeeklyPlanningButtonsActions;
  public connectionType = ConnectionType;
  public currentConnectionType: ConnectionType = ConnectionType.NONE;

  constructor(
    private _modalCtrl: ModalController,
    private _networkService: NetworkService,
    private _eventService: EventService
  ) { }

  ngOnInit() {
    this.subscribeNetworkServiceData();
    this.subscribeEvents();
  }

  ngOnDestroy(): void {
    this._networkServiceSubscription?.unsubscribe();
    this.unsubscribeEvents();
  }

  //#region Subscribe to event-service observable
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();

    this._eventSubscriptions.push(
      this._eventService.OnMakeForceLogout.subscribe(() => {
        this._modalCtrl.dismiss();
      })
    );
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }
  //#endregion

  /**
   * Subscribe to the public Observable of "NetworkService", which emits each time the connection change of type/state. A local property is changed to
   * reflect the new value.
   */
  private subscribeNetworkServiceData(): void {
    this._networkServiceSubscription =
      this._networkService.currentConnectionType.subscribe(
        (currentConnectionType: ConnectionType) => {
          this.currentConnectionType = currentConnectionType;

          this.toolBarColor = StaticClass.getComponentColorByNetworkState(
            this.currentConnectionType
          );
        }
      );
  }

  /**
   * Returns the value of the pressed button
   * @param itemCode pressed button value
   */
  public onClickDismiss(itemCode: number): void {
    this._modalCtrl.dismiss(itemCode);
  }

  /**
   * Exit without press confirm
   */
  public onClickCancel() {
    this._modalCtrl.dismiss();
  }
}
